import React, {useEffect, useState} from "react";
import withRouter from "components/Common/withRouter";
import {useDispatch, useSelector} from "react-redux";
import {
  getLambdas,
  getRunbookScripts,
  getExecuteResults,
  getDaemonDetail
} from "../../store/daemon/actions";

import {
  Row,
  Col,
} from "reactstrap";

import {Link} from "react-router-dom";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import DocsTooltip from "../../components/Common/DocsTooltip";
import {getLocalDateTime} from "../../helpers/component_helpers";
import CardItem from "../../components/PurpleTheme/CardItem";
import TableHeaders from "../../components/Daemon/TableHeaders";
import {useParams} from "react-router";

const DaemonPage = () => {
  const dispatch = useDispatch();
  const params = useParams();

  const [daemonToolTip, setDaemonToolTip] = useState(false);
  const [requestResponseToolTip, setRequestResponseToolTip] = useState(false);

  const requestResponseHeaders = [
    {name: "Request ID", width: 2},
    {name: "Status", width: 2},
    {name: "Request Sent At", width: 4},
    {name: "Response Received At", width: 4},
  ]

  const {daemon_details} = useSelector(state => ({
    daemon_details: state.Daemon.daemon_detail,
  }))

  useEffect(() => {
    dispatch(getDaemonDetail(params.daemonId))
  }, [])

  return (
    <React.Fragment>
      <Row>
        <Col>
          <Row>
            <div className="d-flex gap-1">
              <Breadcrumbs
                title={"Daemon Details"}
                breadcrumbItem={"Daemon Details"}
              />
              <span role="button" className="align-items-center" id='daemonTooltips'>
                  <i className="bx bx-help-circle font-size-16 text-white"/>
                </span>
              <DocsTooltip
                placement={'right'}
                isOpen={daemonToolTip}
                toggle={() => {
                  setDaemonToolTip(!daemonToolTip)
                }}
                targetId={'daemonTooltips'}
                multipleLinks={[
                  {
                    linkText: 'Daemon Deployment',
                    link: 'https://docs.temperstack.com/temperstack'
                  },
                ]}
              />
            </div>
            <div className="card-transparent">
              <div className="table-responsive">
                <table className="table-purple-org no-background">
                  <tbody className="table-dark">
                  <tr>
                    <td scope="row">Monitored Resource</td>
                    <td><Link to={`/resource/${daemon_details?.monitored_resource_id}/alerts`}> {daemon_details?.monitored_resource_id}</Link></td>
                  </tr>
                  <tr>
                    <td scope="row">Daemon ID</td>
                    <td>{daemon_details?.id}</td>
                  </tr>
                  <tr>
                    <td scope="row">Last Seen At</td>
                    <td>{getLocalDateTime(daemon_details?.last_seen)}</td>
                  </tr>
                  <tr>
                    <td scope="row">Status</td>
                    <td>
                      <span
                        style={{
                          display: "inline-block",
                          width: "10px",
                          height: "10px",
                          backgroundColor: daemon_details?.online ? "green" : "red",
                          borderRadius: "50%",
                          marginLeft: "8px",
                        }}
                      ></span>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <hr/>
          </Row>
        </Col>
        <Col>
          <div className="d-flex gap-1">
            <Breadcrumbs
              title={"Request and Responses"}
              breadcrumbItem={"Request and Responses"}
            />
            <span role="button" className="align-items-center" id='requestResponseToolTips'>
                <i className="bx bx-help-circle font-size-16 text-white"/>
              </span>
            <DocsTooltip
              placement={'right'}
              isOpen={requestResponseToolTip}
              toggle={() => {
                setRequestResponseToolTip(!requestResponseToolTip)
              }}
              targetId={'requestResponseToolTips'}
              multipleLinks={[
                {
                  linkText: 'Request and Responses',
                  link: 'https://docs.temperstack.com/temperstack/'
                },
              ]}
            />
          </div>
          <div className='card-transparent'>
            <TableHeaders headers={requestResponseHeaders} className="mt-1"/>
            <div>
              {daemon_details?.execute_requests?.map((execute_request, index) => (
                <CardItem
                  key={index}
                  className="card-item"
                >
                  <Row key={index} className="mx-1  py-1">
                    <Col
                      md={requestResponseHeaders[0].width}
                      lg={requestResponseHeaders[0].width}
                      className="align-items-center justify-content-center py-1 d-flex"
                      style={{
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        direction: 'ltr',
                        textAlign: 'start',
                      }}
                    >
                      <span
                        style={{
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          display: 'block'
                        }}
                      >
                        {execute_request?.id}
                      </span>
                    </Col>
                    <Col
                      md={requestResponseHeaders[1].width}
                      lg={requestResponseHeaders[1].width}
                      className={
                        "align-items-center justify-content-center py-1 d-flex" +
                        (execute_request?.state === "SUCCESS" ?
                          "text-success" :
                          execute_request?.state === "PENDING" ?
                            "text-warning" :
                            "text-danger")
                      }
                    >
                      {execute_request?.state}
                    </Col>
                    <Col
                      md={requestResponseHeaders[2].width}
                      lg={requestResponseHeaders[2].width}
                      className="align-items-center justify-content-center py-1 d-flex"
                    >
                      {getLocalDateTime(execute_request?.request_sent_at)}
                    </Col>
                    <Col
                      md={requestResponseHeaders[3].width}
                      lg={requestResponseHeaders[3].width}
                      className="align-items-center justify-content-center py-1 d-flex"
                    >
                      {getLocalDateTime(execute_request?.response_received_at)}
                    </Col>
                  </Row>
                </CardItem>
              ))}
            </div>
          </div>
        </Col>
      </Row>
    </React.Fragment>
  )
}

DaemonPage.propTypes = {}

export default withRouter(DaemonPage);

